(function () {

  'use strict';

  eclipseApp.directive('body', function () {
    return {
      restrict: 'E',
      scope: false,
      controller: ['$scope', '$element', '$rootScope', 'util', 'env', '$timeout', 'signinService', function ($scope, $element, $rootScope, util, env, $timeout, signinService) {

        // add env name
        $scope.envName = env.name;
        $scope.signinService = signinService;
        $scope.showLoadingIndicator = signinService.getLoadingIndicator;

        // catch click events; if the user is an agent, renew their session
        $($element[0]).parent().on('click', function(e){
          if ($rootScope.ruiMethods.user.is.agent()){
            $timeout(function () {
              util.renewAgentSession();
            }, 0);
          }
        });

        if ($.restive.isPhone()){
          $($element[0]).find("#ute-page").on('click', function(e){
            $rootScope.mobileNavOpen = false;
          });
        }

      }]
    };
  });

})();
